export default {
    init() {
        const glitch = document.querySelectorAll('[data-glitch]')

        glitch.forEach(element => {
            const delay = element.getAttribute('data-glitch')

            const swipe = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    toggleActions: 'play none play reset',
                },
                delay: delay,
            })

            swipe
                .fromTo(element, { x: '-104%' }, { x: '0%', duration: 0.5, ease: 'circ.inOut' })
                .to(element, { x: '100%', duration: 0.5, ease: 'circ.inOut' })
                .set(element, { x: '-100%' })
                .to(element, { x: '0%', duration: 0.65, ease: 'circ.inOut' })
        })
    },
}
